(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fast-filters"] && !Shopify.designMode) return;
  try {
    
  class FastFiltersCarousel extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      if (!this.slideshow) return;

      this.updateArrowVisibility = this.updateArrowVisibility.bind(this);
      
      // Update on slideshow events
      this.slideshow.addEventListener('slideshow:select', this.updateArrowVisibility);
      
      // Initial update
      requestAnimationFrame(() => {
        this.updateArrowVisibility();
      });

      // Update on resize
      this.resizeObserver = new ResizeObserver(() => {
        this.updateArrowVisibility();
      });
      this.resizeObserver.observe(this.slideshow);
    }

    disconnectedCallback() {
      if (this.slideshow) {
        this.slideshow.removeEventListener('slideshow:select', this.updateArrowVisibility);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    updateArrowVisibility() {
      if (!this.slideshow) return;

      const atStart = this.slideshow.atStart;
      const atEnd = this.slideshow.atEnd;

      // Update attributes for CSS styling
      if (atStart) {
        this.slideshow.setAttribute('at-start', '');
      } else {
        this.slideshow.removeAttribute('at-start');
      }

      if (atEnd) {
        this.slideshow.setAttribute('at-end', '');
      } else {
        this.slideshow.removeAttribute('at-end');
      }

      // Update button disabled state
      const prevButton = this.slideshow.querySelector('slideshow-arrow[action="previous"] button');
      const nextButton = this.slideshow.querySelector('slideshow-arrow[action="next"] button');

      if (prevButton) prevButton.disabled = atStart;
      if (nextButton) nextButton.disabled = atEnd;
    }
  }

  if (!customElements.get('fast-filters-carousel')) {
    customElements.define('fast-filters-carousel', FastFiltersCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
